// Warden override (MOB special, M22.1). PURE (ENG-1).
//
// A blind deep-dark hunter. On spawn it emerges over WARDEN.EMERGE_TICKS — rooted
// in place, unable to act — then chases and melees its quarry. Its armour-piercing
// sonic boom is fired host-side (needs the true-damage player path); this override
// covers the emerge gate + the ground chase/strike (reusing the melee primitive).
import { WARDEN } from '../../config';
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { meleeAI } from '../archetypes/melee';
import { wardenEmerged } from '../../game/warden';

export function warden(e: Entity, def: MobDef, ctx: MobContext): void {
  // Emerge window: rooted, no target, ticking down toward the fight.
  if (e.data.wardenEmerge === undefined) e.data.wardenEmerge = WARDEN.EMERGE_TICKS;
  if (!wardenEmerged(e.data.wardenEmerge)) {
    e.data.wardenEmerge -= 1;
    e.wishX = 0; e.wishZ = 0; e.targetIdx = -1;
    return;
  }
  meleeAI(e, def, ctx); // chase + strike the nearest quarry
}
